var _path, _mask, _path2, _path3, _mask2, _path4, _mask3, _path5, _mask4, _path6, _mask5, _path7, _mask6, _path8, _mask7, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMotel = function SvgMotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M33.502 16.43V37M33.502 16.43h6.373M33.502 16.43 29.375 9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "motel_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 30.381c0-.211.172-.383.383-.383h7.234c.211 0 .383.172.383.383v6.234a.383.383 0 0 1-.383.383h-7.234a.383.383 0 0 1-.383-.383z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.606 30.381c0-.705.572-1.277 1.277-1.277h7.234c.705 0 1.277.572 1.277 1.277l-1.788.511h-6.212zm8.894 6.617h-8zm-7.617 0a1.277 1.277 0 0 1-1.277-1.277v-5.34c0-.705.572-1.277 1.277-1.277l.51 1.788v6.106zm7.234-7.894c.705 0 1.277.572 1.277 1.277v5.34c0 .705-.572 1.277-1.277 1.277h-.51v-6.106z",
    mask: "url(#motel_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M21.5 30.998v6"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "motel_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.38 16.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.38 16.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z",
    mask: "url(#motel_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "motel_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.38 23.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.38 23.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z",
    mask: "url(#motel_svg__c)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "motel_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.38 16.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.38 16.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z",
    mask: "url(#motel_svg__d)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "motel_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.38 23.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19.38 23.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z",
    mask: "url(#motel_svg__e)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "motel_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.38 16.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.38 16.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z",
    mask: "url(#motel_svg__f)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "motel_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.38 23.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M25.38 23.998a2 2 0 0 1 4 0v2.803a.197.197 0 0 1-.197.197h-3.605a.197.197 0 0 1-.197-.197z",
    mask: "url(#motel_svg__g)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "M13.786 9 9.5 16.929v20.357h30.857V16.714L35.857 9zM29.503 8.999H18.5L18.5 6.516h11.002z"
  })));
};
export default SvgMotel;